import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

interface MockServerEndPoints {
  req_method: string;
  req_url: string;
  res_status: number;
  res_case: string;
  req_lastUpdated?: string; // Optional property for last updated time
}

interface AdminWidgetSettings {
  endpoint: string;
  case: string;
  updatedTime: string;
}


@Component({
  selector: 'app-view-mockserver-settings',
  templateUrl: './view-mockserver-settings.component.html',
  styleUrls: ['./view-mockserver-settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewMockserverSettingsComponent implements OnInit {
  mockServerEnabled: boolean = false;

  confirmModal?: NzModalRef;
  constructor(private modal: NzModalService) { }

  listOfMockServerEndPoints: MockServerEndPoints[] = [];



  confirmDeletion(data: MockServerEndPoints): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: 'Do you Want to delete this setting?',
      nzContent: `Are you sure you want to delete ${data.req_method} ${data.req_url}?`,
      nzOnOk: () =>
        new Promise((resolve, reject) => {
          try {
            // Remove the item from localStorage
            this.removeFromLocalStorage(data);
            resolve(true);
          } catch (error) {
            console.error('Error deleting setting:', error);
            reject(error);
          }
        }).catch(() => console.log('Oops errors!'))
    });
  }

  private removeFromLocalStorage(dataToDelete: MockServerEndPoints): void {
    // Get current settings from localStorage
    const adminWidgetSettings = localStorage.getItem('adminWidgetSettings');
    if (adminWidgetSettings) {
      try {
        const settings: AdminWidgetSettings[] = JSON.parse(adminWidgetSettings);
        
        // Find and remove the matching setting
        const updatedSettings = settings.filter(setting => {
          const [method, url] = setting.endpoint.split(' ');
          return !(method === dataToDelete.req_method && url === dataToDelete.req_url);
        });

        // Update localStorage
        localStorage.setItem('adminWidgetSettings', JSON.stringify(updatedSettings));

        // Update the local array
        this.listOfMockServerEndPoints = this.listOfMockServerEndPoints.filter(item => 
          !(item.req_method === dataToDelete.req_method && item.req_url === dataToDelete.req_url)
        );
      } catch (error) {
        console.error('Error updating localStorage:', error);
        throw error;
      }
    }
  }



  // listOfDisplayData = [...this.listOfMockServerEndPoints];
  //  searchValue = '';
  // visible = false;
  // reset(): void {
  //   this.searchValue = '';
  //   this.search();
  // }

  // search(): void {
  //   this.visible = false;
  //   this.listOfDisplayData = this.listOfMockServerEndPoints.filter((item: MockServerEndPoints) => item.req_url.indexOf(this.searchValue) !== -1);
  // }
  ngOnInit() {
    // Get mockServerEnabled from localStorage
    const storedValue = localStorage.getItem('mockServerEnabled');
    this.mockServerEnabled = storedValue ? JSON.parse(storedValue) : false;

    // Get adminWidgetSettings from localStorage
    const adminWidgetSettings = localStorage.getItem('adminWidgetSettings');
    if (adminWidgetSettings) {
      try {
        const settings: AdminWidgetSettings[] = JSON.parse(adminWidgetSettings);
        this.listOfMockServerEndPoints = settings.map(setting => {
          // Parse the endpoint string to extract method and URL
          const [method, url] = setting.endpoint.split(' ');
          return {
            req_method: method,
            req_url: url,
            res_status: 200, // Default status code
            res_case: setting.case,
            req_lastUpdated: setting.updatedTime || new Date().toISOString() // Use stored updatedTime or fallback to current timestamp
          };
        });
      } catch (error) {
        console.error('Error parsing adminWidgetSettings from localStorage:', error);
        this.listOfMockServerEndPoints = [];
      }
    }
  }

}
